import {ref, reactive, computed, watch, watchEffect} from 'vue';
import {usePaging} from "@/modules/reader/book/paging";
import config from "@/config/config.json";
import {saveBookmark } from "@/modules/localDB/bookmarkHistory"
import {sortNumeric} from "@/modules/utils/arrayUtils";
import {useDataLoader} from "@/modules/reader/book/dataLoader";
import {i18n} from "@/modules/i18n/i18n";

const bookmarkState = reactive({
    isShow:false,
    bookmarkedPages:[],
    isEditing:false,  //tell whether bookmark is ready to edit
    hasDeletion:false, //tell whether if any bookmarks have been deleted.
    viewMode:"thumbnail",
    containerScrollTop:{
        thumbnail:0,
        list:0
    }
})

export function useBookmark() {

    const {pageState, setCurrentPage} = usePaging();
    const { bookData} = useDataLoader();

    const reset = ()=> {
        console.log("reset @bookInfo.js")
        bookmarkState.isShow = false;
        bookmarkState.bookmarkedPages = [];
        bookmarkState.isEditing = false;
        bookmarkState.hasDeletion = false;
        bookmarkState.containerScrollTop = {
            thumbnail:0,
            list:0
        }
    }

    const hasBookmark = computed(()=>{
        return bookmarkState.bookmarkedPages.length;
    })

    const addBookmark = async ()=>{

        let isAlreadyBookmarked = false;
        if (pageState.isRightPageAvailable) {

            let isLeftPageBookmarked = bookmarkState.bookmarkedPages.indexOf(pageState.currentPage[0]) >=0;
            let isRightPageBookmarked = bookmarkState.bookmarkedPages.indexOf(pageState.currentPage[1]) >=0;
            if (isLeftPageBookmarked  && isRightPageBookmarked) {
                isAlreadyBookmarked = true;
            } else {
                if (!isLeftPageBookmarked) {
                    bookmarkState.bookmarkedPages.push(pageState.currentPage[0]);
                }
                if (!isRightPageBookmarked) {
                    bookmarkState.bookmarkedPages.push(pageState.currentPage[1]);
                }
            }
        } else {
            if (bookmarkState.bookmarkedPages.indexOf(pageState.currentPage[0]) === -1) {
                bookmarkState.bookmarkedPages.push(pageState.currentPage[0]);
            } else {
                isAlreadyBookmarked = true;
            }
        }

        if (isAlreadyBookmarked) {
            alert(i18n.t("info_bookmark_already_added"))
        } else {
            reOrderBookmark();
        }

        await saveBookmark();

    }

    const deleteBookmark = async (index)=> {
        bookmarkState.bookmarkedPages.splice(index,1);
        reOrderBookmark();
        bookmarkState.hasDeletion = true;

        await saveBookmark();
    }

    const toggleBookmark = ()=>{
        bookmarkState.isShow = !bookmarkState.isShow;
    }

    const reOrderBookmark = ()=>{
        bookmarkState.bookmarkedPages = sortNumeric(bookmarkState.bookmarkedPages);
    }

    /**
     * Restore bookmarks.
     * Called when book is opened, or restoring from sync server.
     * The boolean parameter isRestoreFromSync indicates it's restoring from sync server, and save the data to local db.
     * @param history
     * @param isRestoreFromSync
     */
    const restoreBookmarkHistory = async (history, isRestoreFromSync)=>{

        //we use zero-based for reactive array. Minus one since the local db uses one-based for app version backward compatibility...
        bookmarkState.bookmarkedPages = history.map(el=>{return parseInt(el)-1});

        if (isRestoreFromSync) {
            await saveBookmark(isRestoreFromSync);
        }
    }


    const toggleEdit = ()=>{
        if (!bookmarkState.isEditing) {
            bookmarkState.isEditing = true;
        } else {
            bookmarkState.isEditing = false;
            bookmarkState.hasDeletion = false;
        }
    }

    const gotoBookmarkedPage = (item)=>{
        setCurrentPage( bookData.pagenames.indexOf(String(bookData.pagenames[item])));
        bookmarkState.isShow = false;
    }

    return {
        hasBookmark,
        bookmarkState,
        gotoBookmarkedPage,
        toggleBookmark,
        addBookmark,
        deleteBookmark,
        restoreBookmarkHistory,
        toggleEdit,
        reset
    }
}
